<template>
  <div>
    <el-row>
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="20">
        <div class="title">
          <h1>CIA: VR Contextual Immersion Attachment</h1>
        </div>
        <div class="picture">
          <img src="../assets/project19_1.png.webp" />
        </div>
        <div class="abstract">
          When VR users need to retrieve real-world objects or check object states, the visual channel is fully occupied by the VR headset, so users often have to remove or disengage from the headset. This seriously breaks immersion and interrupts the experience flow.
          <br /><br />
          This study introduces the concept of contextualized reality-perception enhancement, which selectively and contextually enhances users' perception of key elements in the real world. Therefore, we designed CIA, a VR contextual immersion attachment that can rapidly register specific real-world objects.
          <br /><br />
          CIA enables seamless and efficient interaction with key real-world objects, bridging the interaction gap between virtual and real worlds.
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="20"><div class="picture"><img src="../assets/project19_2.png.webp" /></div></el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="20"><div class="picture"><img src="../assets/project19_3.png.webp" /></div></el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="20"><div class="picture"><img src="../assets/project19_4.png.webp" /></div></el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "Project19",
};
</script>

<style scoped>
.picture img {
  width: 100%;
}
.abstract {
  margin-top: 24px;
  font-size: 15px;
  color: #333;
  font-weight: 100;
  text-align: justify;
  line-height: 1.9;
}
.grid-content {
  min-height: 36px;
}
.title {
  margin-top: 100px;
  text-align: center;
}
.title h1 {
  font-size: 30px;
  font-weight: 100;
  letter-spacing: 3px;
  color: #333333;
}
</style>
